import React from "react";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import get_parameter_by_name from "../legacy/helpers/get_parameter_by_name";
import _isObject from "lodash/isObject";

import { withRouter } from "react-router";

import { COLORS } from "../constants/colors";

class NounProjectSearch extends React.PureComponent {
    activeScope(propsScope, state) {
        if (!state) {
            state = this.state;
        }
        // returns activeScope object if a scope matches the url pattern
        let activeScope;

        state.scopes.forEach(scope => {
            if (scope.name === propsScope) {
                activeScope = scope;
                activeScope.checked = scope.defaultChecked;
            } else if (!propsScope && scope.regex !== undefined) {
                if (scope.regex.test(location.pathname)) {
                    // we have to check a regex match for fort pages because we dont have any other data to go off of
                    activeScope = scope;
                    // Set fort scopes to be active by default
                    activeScope.checked = true;
                }
            }
        });
        return activeScope;
    }

    addBackScopeSearch(scope) {
        // when user toggels to search via scope again
        this.setState({
            activeScope: scope,
            removeScopeSearch: false
        });
    }

    handleKeyup(event) {
        let codes = {
                up: 38,
                down: 40,
                right: 39,
                left: 37,
                enter: 13
            },
            keyCode = event.keyCode;
        // if there are suggestions select them via up and down keys
        if (this.state.suggestions.length > 0) {
            // move selection up and down
            if (keyCode === codes.up) {
                this.autocompleteSelectPrevious();
            } else if (keyCode === codes.down) {
                this.autocompleteSelectNext();
            }
        }

        if (keyCode == codes.enter) {
            this.handleFormSubmit(event);
        } else {
            this.setState({
                submitted: false
            });
        }
    }

    autocompleteSelectNext() {
        // action fired when user arrow keys to next autocomplete selection
        let currentSelected,
            suggestions = JSON.parse(JSON.stringify(this.state.suggestions));

        this.state.suggestions.forEach(suggestion => {
            if (suggestion.selected) {
                currentSelected = suggestion;

                // Find next term to select
                // nextIndex is always the index of the current selected term +1
                let currentIndex = this.state.suggestions.indexOf(suggestion),
                    nextIndex = currentIndex + 1;

                // if the nextIndex is greater than total suggestions (5) set nextIndex to just be the last term
                if (nextIndex === this.state.suggestions.length) {
                    nextIndex = this.state.suggestions.length - 1;
                }

                // updated selected properties
                suggestions[currentIndex].selected = false;
                suggestions[nextIndex].selected = true;
            }
        });

        // if no terms are selected select the first
        if (!currentSelected) {
            // clone suggestion state to modify it
            suggestions[0].selected = true;
        }

        this.setState({
            suggestions: suggestions
        });
    }

    autocompleteSelectPrevious() {
        // action fired when user arrow keys to previous autocomplete selection
        let currentSelected,
            suggestions = JSON.parse(JSON.stringify(this.state.suggestions));

        this.state.suggestions.forEach(suggestion => {
            if (suggestion.selected) {
                currentSelected = suggestion;

                // Find next term to select
                // previous is always the index of the current selected term - 1
                let currentIndex = this.state.suggestions.indexOf(suggestion),
                    previous = currentIndex - 1;

                // if the nextIndex is less than total suggestions (5) set all selected to false
                if (previous >= 0) {
                    // updated previous selected property
                    suggestions[previous].selected = true;
                }

                // set unselect current term
                suggestions[currentIndex].selected = false;
            }
        });

        this.setState({
            suggestions: suggestions
        });
    }

    componentWillReceiveProps(nextProps) {
        let { history } = nextProps;

        // Update query in state from url when location changes
        if (
            history &&
            history.location.search != this.state.lastHistorySearch
        ) {
            let newQuery = get_parameter_by_name("q", history.location.search);
            this.setState({
                query: newQuery,
                lastHistorySearch: history.location.search
            });
        }
        if (this.props.scope !== nextProps.scope) {
            this.setState({
                activeScope: this.activeScope(nextProps.scope),
                suggestions: nextProps.suggestions || []
            });
        } else {
            this.setState({
                suggestions: nextProps.suggestions || []
            });
        }
    }

    componentDidMount() {
        this.setState({
            lastHistorySearch: this.props.history.location.search
        });
    }

    constructor(props) {
        super(props);

        this.state = {
            scopes: [
                {
                    checked: false,
                    name: "creator",
                    text: "Search by this creator",
                    placeholderText: "Search for anything by this creator",
                    regex: undefined,
                    fort: false,
                    defaultChecked: true
                },
                {
                    name: "collection",
                    text: "Search in this collection",
                    placeholderText: "Search in this collection",
                    fort: false,
                    regex: undefined,
                    checked: false,
                    defaultChecked: !!get_parameter_by_name(
                        "collection",
                        props.location.search
                    )
                }, // user's collection /edward/collection/aiga/
                {
                    name: "fort members",
                    text: "fort members",
                    regex: new RegExp(/fort\/members/),
                    fort: true
                }, // fort members /fort/members/
                {
                    name: "fort collections",
                    text: "fort collections",
                    regex: new RegExp(/fort\/collections/),
                    fort: true
                }, // fort collections /fort/collections/
                {
                    name: "fort icons",
                    text: "fort icons",
                    regex: new RegExp(/fort\/icon/),
                    fort: true
                } // fort icons /fort/icon/
            ],
            showSuggestions: false,
            suggestions: [],
            query: props.query
        };
        this.state.activeScope = this.activeScope(props.scope, this.state);
    }

    getSuggestions(event) {
        // action to get autocomplete suggestions
        let rawInput = event.target.value;
        let query = rawInput.trim().toLowerCase();

        this.setState({
            query: rawInput
        });
        let { viewport } = this.props;
        if (viewport.width <= 768) {
            // mobile so don't get suggestions
            return;
        }

        if (this.state.activeScope && this.state.activeScope.fort) {
            // no suggestions for fort
            return;
        }

        if (query.length <= 2) {
            // don't bother if less than 3 chars
            this.setState({
                showSuggestions: false,
                suggestions: []
            });
            return;
        }

        this.setState({
            showSuggestions: true,
            suggestions: []
        });

        this.props.fetchAutoCompleteTerms(query);
    }

    removeSuggestions() {
        this.setState({
            removeScopeSearch: false,
            suggestions: []
        });
    }

    removeScopeSearch() {
        // fired when the user doesn't want to search by scope
        this.setState({
            removeScopeSearch: true
        });
    }

    handleFormSubmit = e => {
        this.setState({
            submitted: true
        });
        let current =
            this.state.suggestions &&
            this.state.suggestions.filter(s => s.selected)[0];

        if (!current) {
            this.submitSearch(e, this.state.query);
        } else {
            this.submitSearch(e, current.term);
        }
    };

    render() {
        let placeHolder = "Search for anything",
            searchScope = this.renderSearchScope(),
            autocompleteContainer = this.renderAutocompleteContainer();

        if (location.pathname === "/search/collection/") {
            placeHolder = "Search for any collection";
        } else if (this.state.activeScope && this.state.activeScope.checked) {
            placeHolder = this.state.activeScope.placeholderText;
        }

        return (
            <div className="search-container">
                <form
                    action="/search/"
                    type="GET"
                    autoComplete="off"
                    spellCheck="false"
                    onSubmit={this.handleFormSubmit}
                >
                    <label className="ui_search" htmlFor="search" />
                    <input
                        id="search"
                        type="search"
                        name="q"
                        placeholder={placeHolder}
                        onChange={this.getSuggestions.bind(this)}
                        onKeyUp={this.handleKeyup.bind(this)}
                        value={this.state.query}
                        autoComplete="off"
                        spellCheck="false"
                        ref={input => {
                            this.searchInput = input;
                        }}
                        data-test-id="search-input"
                    />
                    <div className="search-scope-container">{searchScope}</div>
                    <input
                        type="submit"
                        style={{
                            position: "absolute",
                            left: "-9999px",
                            width: "1px",
                            height: "1px"
                        }}
                        tabIndex="-1"
                    />
                </form>
                {autocompleteContainer}
            </div>
        );
    }

    renderSearchScope() {
        // renders the search on scope badge on the input based on user/collection/fort scopes
        let searchScope;

        if (!this.state.activeScope) {
            return;
        }

        if (!this.state.removeScopeSearch) {
            if (this.state.activeScope.fort) {
                let fortScopes = [
                    <option key={0} value={"noun project"}>
                        search Noun Project
                    </option>
                ];
                this.state.scopes.forEach(scope => {
                    if (scope.fort) {
                        fortScopes.push(
                            <option key={scope.name} value={scope.name}>
                                search {scope.text}
                            </option>
                        );
                    }
                });
                searchScope = (
                    <div className="fort-select-container bg-offwhite padding-t-xs padding-r-l padding-b-xs padding-l-s margin-r-s">
                        <select
                            className="bg-offwhite"
                            onChange={this.selectFortScope.bind(this)}
                            value={this.state.activeScope.name}
                        >
                            {fortScopes}
                        </select>
                        <span className="ui_down-drop-arrow" />
                    </div>
                );
            } else {
                // dont show scope ui for search collections
                if (location.pathname === "/search/collection/") {
                    return;
                }

                let testId = `${this.state.activeScope.name}-scope`;

                searchScope = (
                    <div style={{ margin: "4px 18px", cursor: "pointer" }}>
                        <input
                            data-test-id={testId}
                            id="search_scope"
                            type="checkbox"
                            checked={this.state.activeScope.checked}
                            name="search_scope"
                            className="hidden"
                            onChange={this.setActiveScopeChecked.bind(this)}
                        />

                        <label
                            htmlFor="search_scope"
                            className="checkbox-fillin"
                            style={{
                                margin: "0 10px",
                                border: `solid 1px ${COLORS.$stone}`,
                                cursor: "pointer"
                            }}
                        >
                            <i
                                style={{
                                    opacity: this.state.activeScope.checked
                                        ? 1
                                        : 0
                                }}
                                className="ui_checkbox"
                            />
                        </label>
                        <label
                            htmlFor="search_scope"
                            style={{ cursor: "pointer" }}
                        >
                            {this.state.activeScope.text}
                        </label>
                    </div>
                );
            }
        }

        return searchScope;
    }

    renderAutocompleteContainer() {
        if (this.state.submitted) {
            return null;
        }
        let dismissSuggestions,
            autocompleteContainer,
            autocompleteList = this.renderAutocompleteList(),
            autocompleteStyles = {
                backgroundColor: COLORS.$offwhite,
                fontSize: "18px",
                position: "absolute",
                width: "100%",
                border: "3px solid #F1F1F1",
                margin: "-3px 0 0 0",
                zIndex: "98"
            };

        if (this.state.showSuggestions) {
            dismissSuggestions = (
                <div
                    className="dismiss-suggestions"
                    onClick={this.removeSuggestions.bind(this)}
                />
            );
        }

        autocompleteContainer = (
            <div style={{ autocompleteStyles }}>
                {dismissSuggestions}
                {autocompleteList}
            </div>
        );

        return autocompleteContainer;
    }

    renderAutocompleteList() {
        // renders autocomplete suggestions
        let autocompleteList = null,
            autocompleteListContainer,
            iconMatchList;

        if (this.state.showSuggestions) {
            autocompleteList = [];
            if (this.state.suggestions.length === 0) {
                // Don't show anything if there isn't any
                return;
            }
            // Figure out if query is the same as the suggestions results query.
            this.state.suggestions.forEach(suggestion => {
                if (suggestion.matched_icon) {
                    // Icon match based on icon ID
                    autocompleteList.push(
                        <li
                            key={`suggestion.${autocompleteList.length}`}
                            className={suggestion.selected ? "active" : ""}
                            style={{
                                listStyle: "none"
                            }}
                        >
                            <a
                                href={`/icon/${suggestion.id}/`}
                                title={gettext("View icon #") + suggestion.id}
                                onClick={e =>
                                    this.submitSearch(
                                        e,
                                        suggestion.term,
                                        suggestion.id,
                                        true
                                    )
                                }
                                style={{
                                    fontFamily:
                                        "Light-45,Helvetica Neue,Helvetica,Arial,sans-serif",
                                    display: "flex",
                                    padding: "8px 0 8px 16px",
                                    alignItems: "center"
                                }}
                            >
                                <img
                                    src={suggestion.preview_url_42}
                                    width="24"
                                    height="24"
                                    style={{
                                        marginRight: "18px"
                                    }}
                                />
                                <span
                                    style={{
                                        position: "relative"
                                    }}
                                >
                                    {suggestion.term}
                                    <span
                                        style={{
                                            color: COLORS.$stone,
                                            paddingLeft: "8px",
                                            fontSize: "14px"
                                        }}
                                    >
                                        icon id: {suggestion.id}
                                    </span>
                                </span>
                            </a>
                        </li>
                    );
                } else {
                    if (this.state.query !== suggestion.query) {
                        // Don't add if it isn't for the current query
                        return;
                    }
                    let querySuggestion = suggestion.term.replace(
                        this.state.query,
                        ""
                    );
                    autocompleteList.push(
                        <li
                            className={suggestion.selected ? "active" : ""}
                            key={`suggestion.${autocompleteList.length}`}
                            style={{
                                paddingLeft: "34px",
                                listStyle: "none"
                            }}
                        >
                            <a
                                href={`/search/?q=${suggestion.term}`}
                                onClick={e =>
                                    this.submitSearch(
                                        e,
                                        suggestion.term,
                                        null,
                                        true
                                    )
                                }
                                title={gettext("Search for ") + suggestion.term}
                                style={{
                                    fontFamily:
                                        "Light-45,Helvetica Neue,Helvetica,Arial,sans-serif",
                                    display: "block",
                                    padding: "8px 0 8px 24px"
                                }}
                            >
                                <span className="query-matched">
                                    {this.state.query}
                                </span>
                                <span className="query-suggestion">
                                    {querySuggestion}
                                </span>
                            </a>
                        </li>
                    );
                }
            });

            autocompleteListContainer = (
                <section
                    id="autocomplete"
                    className="autocomplete-container autocomplete"
                    style={{ display: "flex", borderTop: "3px solid #F2F2F2" }}
                >
                    <ul
                        style={{
                            width: "100%"
                        }}
                    >
                        {autocompleteList}
                    </ul>
                </section>
            );
        }

        return autocompleteListContainer;
    }

    removeSuggestions() {
        // dismisses the html
        this.setState({
            showSuggestions: false,
            suggestions: []
        });
    }

    selectFortScope(e) {
        let newActiveScope;
        this.state.scopes.forEach(scope => {
            if (scope.name === e.target.value) {
                let activeScope = Object.assign({}, scope);
                newActiveScope = activeScope;
                newActiveScope.checked = true;
            }
        });
        if (!newActiveScope) {
            newActiveScope = Object.assign({}, this.state.activeScope);
            newActiveScope.name = "noun project";
            newActiveScope.name = "Noun Project";
        }
        this.setState({
            activeScope: newActiveScope
        });
    }

    setActiveScopeChecked(e) {
        let activeScope = Object.assign({}, this.state.activeScope);
        activeScope.checked = this.state.activeScope.checked ? false : true;
        this.setState({
            activeScope: activeScope
        });
    }

    showSuggestions() {
        if (this.state.showSuggestions === false) {
            this.searchInput.focus();
            this.setState({
                showSuggestions: true
            });
        } else {
            this.searchInput.focus();
            this.setState({
                showSuggestions: false
            });
        }
    }

    submitSearch(e, query, icon_id, clicked = false) {
        e.preventDefault();
        if (this.state.submitted) {
            return null;
        }
        let searchTerm = encodeURIComponent(query);

        if (this.state.suggestions.length > 0 && !clicked) {
            // if suggestions visible, check if any are currently selected for the searchTerm
            this.state.suggestions.forEach(suggestion => {
                if (suggestion.selected) {
                    if (suggestion.matched_icon) {
                        // search for icon
                        icon_id = suggestion.id;
                    } else {
                        // search for term
                        searchTerm = suggestion.term;
                    }
                }
            });
        }

        let { location } = this.props.history;

        let searchURL;
        let collectionSearchUrl = "/search/collection/";
        if (location.pathname == collectionSearchUrl) {
            searchURL = `/search/collection/?q=${searchTerm}`;
        } else {
            searchURL = `/search/?q=${searchTerm}`;
        }

        if (!this.state.removeScopeSearch) {
            if (this.state.activeScope) {
                if (this.state.activeScope.checked) {
                    if (this.state.activeScope.fort) {
                        // search in fort
                        switch (this.state.activeScope.name) {
                            case "fort members":
                                searchURL = `/fort/members/?q=${searchTerm}`;
                                break;
                            case "fort collections":
                                searchURL = `/fort/collections/?slug=${searchTerm}`;
                                break;
                            case "fort icons":
                                searchURL = `/fort/icon/${searchTerm}/`;
                                break;
                        }
                    } else {
                        switch (this.props.scope) {
                            case "creator":
                                searchURL = `/search/?q=${searchTerm}&creator=${this.props.scope_id}`;
                                break;
                            case "collection":
                                searchURL = `/search/?q=${searchTerm}&collection=${this.props.scope_id}`;
                                break;
                        }
                    }
                }
            }
        }

        if (icon_id) {
            // Icon ID wins over all, when someone clicks suggestion
            searchURL = `/icon/${icon_id}/`;
            return this.props.redirect(searchURL);
        }
        if (
            location.pathname != "/search/" ||
            !this.props.resultsComponentPresent
        ) {
            this.props.redirect(searchURL);
        } else {
            this.props.history.push(searchURL);

            this.setState({
                submitted: true,
                query,
                lastHistorySearch: null
            });

            this.props.pageview(searchURL);
        }
    }
}

function mapStateToProps(state, props) {
    let creator,
        creator_id,
        collection,
        query,
        result_type,
        scope,
        scope_id,
        suggestions;
    let { viewport, search } = state;
    let { resultsComponentPresent } = search;
    let { location } = props;
    query = get_parameter_by_name("q", location.search) || "";
    creator = get_parameter_by_name("creator", location.search) || "";
    collection = get_parameter_by_name("collection", location.search) || "";

    if (creator) {
        scope = "creator";
        scope_id = creator;
    } else if (collection) {
        scope = "collection";
        scope_id = collection;
    } else if (state.icons.scope) {
        ({ scope, scope_id } = state.icons);
    } else if (_isObject(props.scope)) {
        ({ scope, scope_id } = props.scope);
    }

    if (state.search.autocompleteTerms !== undefined) {
        suggestions = [];
        let topFiveTerms = state.search.autocompleteTerms.suggestionKeys.slice(
            0,
            5
        );
        topFiveTerms.forEach(key => {
            suggestions.push(state.search.autocompleteTerms[key]);
        });
    }

    return {
        suggestions,
        creator,
        creator_id,
        collection,
        query,
        result_type,
        scope,
        scope_id,
        viewport,
        resultsComponentPresent
    };
}

const NounProjectSearchWrapped = connect(
    mapStateToProps,
    {
        fetchAutoCompleteTerms: actions.fetchAutoCompleteTerms,
        redirect: actions.redirect,
        pageview: actions.pageview
    }
)(NounProjectSearch);

export default withRouter(NounProjectSearchWrapped);
